import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getClaims, getAdminUsers } from "../../action";
import "../../styles/theme.scss";
import { useTranslation } from "react-i18next";
import { Grid, Typography, Paper, IconButton, Input } from "@mui/material";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import TableN from "../../reusableComponents/components/generics/TableN";
import { clearClaimResp } from "../../store/actions/exampleAction";
const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));
function AdminTable() {
  const SignInSuccess = useSelector((state) => state);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [policyHolderData, setPolicyHolderData] = useState();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageInfo, setPageInfo] = useState();
  const [endCursors, setEndCursors] = useState();
  const [startCursors, setStartCursors] = useState();
  let healthData = SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0];
  const initialFetch = useRef(true);

  useEffect(() => {
    dispatch(clearClaimResp());
  }, []);

  useEffect(() => {
    if (
      healthData?.location?.parent?.uuid &&
      healthData?.location?.uuid &&
      healthData?.uuid &&
      initialFetch.current
    ) {
      let params = buildQueryParams({
        filters: {},
        pageSize,
        beforeCursor: endCursors,
        afterCursor: startCursors,
        orderBy: ["username"],
        onlyFosaUser: true,
        healthFacility_uuid: healthData?.uuid,
      });
      if (
        healthData?.location?.parent?.uuid ||
        healthData?.location?.uuid ||
        healthData?.uuid
      ) {
        dispatch(getAdminUsers(params));
        initialFetch.current = false;
      }
    }
  }, [
    dispatch,
    endCursors,
    healthData,
    healthData?.location?.parent?.uuid,
    healthData?.location?.uuid,
    healthData?.uuid,
    page,
    pageSize,
    startCursors,
  ]);

  const buildQueryParams = (state) => {
    let params = [];

    // Ensure state.filters exists before trying to access its properties
    if (state.filters) {
      params = Object.keys(state.filters)
        .filter((f) => !!state.filters[f]["filter"])
        .map((f) => state.filters[f]["filter"]);
    }

    if (!state.beforeCursor && !state.afterCursor) {
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.afterCursor) {
      params.push(`after: "${state.afterCursor}"`);
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.beforeCursor) {
      params.push(`before: "${state.beforeCursor}"`);
      params.push(`last: ${state.pageSize}`);
    }
    if (!!state.orderBy) {
      params.push(`orderBy: ["${state.orderBy}"]`);
    }
    if (!!state.healthFacility_Location_Parent_Uuid) {
      params.push(
        `healthFacility_Location_Parent_Uuid: "${state.healthFacility_Location_Parent_Uuid}"`
      );
    }
    if (!!state.healthFacility_Location_Uuid) {
      params.push(
        `healthFacility_Location_Uuid: "${state.healthFacility_Location_Uuid}"`
      );
    }
    if (state.healthFacility_uuid) {
      params.push(`healthFacilityUuid: "${state.healthFacility_uuid}"`);
    }

    if (state.onlyFosaUser) {
      params.push(`isFosaUser:true`);
    }

    return params;
  };

  useEffect(() => {
    if (SignInSuccess?.fosaReducer?.adminItems) {
      setPolicyHolderData(SignInSuccess?.fosaReducer?.adminItems);
      setPageInfo(SignInSuccess?.fosaReducer?.adminItemsPageInfo?.totalCount);
      setStartCursors(
        SignInSuccess?.fosaReducer?.adminItemsPageInfo?.endCursor
      );
      setEndCursors(
        SignInSuccess?.fosaReducer?.adminItemsPageInfo?.startCursor
      );
    }
  }, [SignInSuccess]);

  const headers = () => {
    var h = [
      t("adminManagement.identifiant"),
      t("adminManagement.familyName"),
      t("adminManagement.firstName"),
      t("adminManagement.email"),
      t("adminManagement.phoneNumber"),
    ];

    return h;
  };

  const getUserItem = (user, item) =>
    (user.iUser && user.iUser[item]) ||
    (user.officer && user.officer[item]) ||
    (user.claimAdmin && user.claimAdmin[item]);

  const itemFormatters = () => {
    const row = [];
    row.push((u) => u.username);
    row.push((u) => getUserItem(u, "lastName"));
    row.push((u) => getUserItem(u, "otherNames"));
    row.push((u) => getUserItem(u, "email") || getUserItem(u, "emailId"));
    row.push((u) => getUserItem(u, "phone"));
    return row;
  };

  const handleRowsPerPageChange = (newPageSize) => {
    setPageSize(newPageSize);
    setEndCursors(null);
    setStartCursors(null);
    setPage(0); // Reset to the first page when changing page size
  };
  const handleNavigation = (direction) => {
    if (direction === "forward") {
      setEndCursors(null);
    } else if (direction === "backward") {
      setStartCursors(null);
    }
  };
  const handleRowDoubleClick = (rowData) => {
    navigate(`/fosa/adminUsersForm/:id=${rowData.id}`);
  };

  return (
    <Grid container>
      {/* <TableN/> */}
      <Grid item xs={12}>
        <StyledPaper>
          <StyledPaperHeader container alignItems="center" direction="row">
            <Grid item alignItems="center">
              <Typography variant="h6">
                {t("adminManagement.tableList")}-{pageInfo}
              </Typography>
            </Grid>
          </StyledPaperHeader>
          <TableN
            headers={headers()}
            itemFormatters={itemFormatters()}
            items={policyHolderData ?? []}
            withSelection={"single"}
            withPagination={true}
            rowsPerPageOptions={[10, 50, 100]}
            defaultPageSize={5}
            page={page}
            pageSize={pageSize}
            count={pageInfo}
            onChangePage={(event, newPage) => {
              initialFetch.current = true;
              setPage(newPage);
              handleNavigation(newPage > page ? "forward" : "backward");
            }}
            onChangeRowsPerPage={handleRowsPerPageChange}
            onDoubleClick={handleRowDoubleClick}
            // rowLocked={this.rowLocked}
          />
        </StyledPaper>
      </Grid>
    </Grid>
  );
}

export default AdminTable;
